import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import client from '../../lib/feathers';

export default function NewCategoryForm(props) {
  const { onCancelClick, onNewCategory, onUpdateCategory, category } = props;
  const [venueCategoryId, setVenueCategoryId] = useState('');
  const [name, setName] = useState('');
  const [plural, setPlural] = useState('');

  const isEditing = !!category;

  useEffect(() => {
    if (category) {
      setVenueCategoryId(category.venueCategoryId || '');
      setName(category.name || '');
      setPlural(category.plural || '');
    }
  }, [category]);

  const onFormSubmit = async (event) => {
    event.preventDefault();
    const service = client.service('admin/category');

    if (!venueCategoryId.trim()) {
      toast.error('Please enter a category ID');
      return;
    }
    if (!name.trim()) {
      toast.error('Please enter a name');
      return;
    }
    if (!plural.trim()) {
      toast.error('Please enter a plural name');
      return;
    }

    const data = {
      venueCategoryId: venueCategoryId.trim(),
      name: name.trim(),
      plural: plural.trim(),
    };

    try {
      if (isEditing) {
        const result = await service.patch(category.id, data);
        onUpdateCategory(result);
        toast.success(`Updated ${name}`);
      } else {
        const result = await service.create(data);
        onNewCategory(result);
        toast.success(`Added ${name}`);
      }
    } catch (e) {
      console.error('Error saving category:', e);
      if (e.message?.includes('unique') || e.code === 409) {
        toast.error('A category with this ID already exists');
      } else {
        toast.error(isEditing ? 'Failed to update category' : 'Failed to create category');
      }
    }
  };

  return (
    <>
      <div className="mt-3 text-center sm:mt-5">
        <h3 className="text-lg leading-6 font-medium text-gray-900" id="modal-headline">
          {isEditing ? 'Edit Category' : 'Create New Category'}
        </h3>
        <div className="mt-2">
          <p className="text-sm text-gray-500">
            {isEditing ? 'Update the category details.' : 'Enter the details for this category.'}
          </p>
          <form onSubmit={onFormSubmit} className="mt-4">
            <div className="mb-4">
              <label htmlFor="venueCategoryId" className="block text-sm font-medium text-gray-700 text-left">
                Category ID
              </label>
              <input
                type="text"
                value={venueCategoryId}
                onChange={(e) => setVenueCategoryId(e.target.value)}
                required
                name="venueCategoryId"
                id="venueCategoryId"
                autoComplete="off"
                placeholder="e.g., winery, restaurant"
                className="mt-1 focus:ring-gray-500 focus:border-gray-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
              />
            </div>
            <div className="mb-4">
              <label htmlFor="name" className="block text-sm font-medium text-gray-700 text-left">
                Name (Singular)
              </label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                name="name"
                id="name"
                autoComplete="off"
                placeholder="e.g., Winery"
                className="mt-1 focus:ring-gray-500 focus:border-gray-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
              />
            </div>
            <div className="mb-4">
              <label htmlFor="plural" className="block text-sm font-medium text-gray-700 text-left">
                Name (Plural)
              </label>
              <input
                type="text"
                value={plural}
                onChange={(e) => setPlural(e.target.value)}
                required
                name="plural"
                id="plural"
                autoComplete="off"
                placeholder="e.g., Wineries"
                className="mt-1 focus:ring-gray-500 focus:border-gray-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
              />
            </div>
            <div className="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
              <button
                type="submit"
                className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary text-base font-medium text-white hover:bg-red-900 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 sm:col-start-2 sm:text-sm"
              >
                {isEditing ? 'Save' : 'Create'}
              </button>
              <button
                type="button"
                onClick={onCancelClick}
                className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 sm:mt-0 sm:col-start-1 sm:text-sm"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
